import {store} from '../../../store/store'
import {api} from '../../../common/config'
import {ajaxUtil} from '../../../common/AjaxUtil'
import {directive as onClickaway} from 'vue-clickaway';
import {LocalStorageUtil, StorageUtil} from '../../../common/Auth'
import {CommonUtil} from '../../../common/CommonUtil'
import LoginMask from '../../../components/loginmask.vue';
export default {
  name: 'ebookreading',
  directives: {
    onClickaway: onClickaway,
  },
  components:{
    LoginMask
  },
  data() {
    return {
      deleteNewsUrl: '',/*删除书签的url*/
      deleteNews: false,
      view: 0, /*用作计算本书阅读次数，刷新就重计为0,超过及到达20页算一次阅读次数*/
      viewTimes: 0,/*用作阅读限制用，登录以及公共阅读器不计算次数，个人未登录计算次数*/
      isSave: false, //当前页是否保存了书签
      bookmark: [],
      loginTip: false,
      num: 0,
      scrollBarHeight: 0,
      scrollBarHeight_catalogue: 0,
      labels: [],
      rendition: null,
      nowPageUrl: '',/*当前页面的章节url*/
      nowPageCfi: '', /*当前页面的cfi*/
      menus: '',
      catalogues: [],
      catalogueName: '',
      percentage: '',
      labelScroll: null,
      showLabel: false,
      showCatalogue: false,
      platform: 0,
      user: null,
      history: '',
      file: '',
      id: '',
      libCode: '',
      isReader:false,
      libName:'',
    }
  },
  beforeMount() {
    this.file = decodeURI(this.$route.query.url);
    this.id = this.$route.query.id || '';
    this.libCode = this.$route.query.libCode || '';
    this.libName = this.$route.query.libName || '';
    this.user = store.func.getUserObj();
    this.platform = CommonUtil.checkPlatform();
    this.bookmark = LocalStorageUtil.getObject(this.file) || [];
    var viewTimeList = LocalStorageUtil.getObject('viewTimes') || [];
    for(var i = 0; i < viewTimeList.length; i++) {
      if(viewTimeList[i].file == this.file) {
        this.viewTimes = viewTimeList[i].times-1;
        break;
      }
    }
  },
  mounted() {
    var _this = this;
    // Load the opf
    var book = ePub(this.file);
    // var book = ePub("https://s3.amazonaws.com/epubjs/books/moby-dick/OPS/package.opf");
    this.book = book;
    // var book = ePub('http://ebook.ytsg.cn/ebooks/epub/4/7/1527844724647.epub');
    var rendition = book.renderTo("viewer", {
      width: "100%",
      height: "100%",
    });
    this.rendition = rendition;
    rendition.themes.default(
      {
        "body": {
          "color": "#333",
          "background": "#fefbf2",
        },
        ".epub-view": {
          "background": "rgba(255,255,255,1)",
        },
        "p": {
          "font-family": "微软雅黑",
          "font-size": "18px!important"
        },
        "p span": {
          "font-family": "微软雅黑!important",
          "font-size": "18px!important"
        },
        ".sgc-toc-level-1 a, .sgc-toc-level-2 a": {
          "color": "#333",
        },
        ".sgc-toc-level-2, .sgc-toc-level-1": {
          "line-height": '24px',
        }
      }
    );
    var displayed = null;
    _this.history = LocalStorageUtil.getObject('nowPageCfi');
    if(_this.history != '' && _this.history != null) {
      displayed = rendition.display(_this.history);
    } else {
      displayed = rendition.display()
    }

    book.ready.then(() => {
      var next = document.getElementById("next");
      next.addEventListener("click", function (e) {
        if(!_this.watchCheck()) {
          return false
        }
        book.package.metadata.direction === "rtl" ? rendition.prev() : rendition.next();
        e.preventDefault();
      }, false);

      var prev = document.getElementById("prev");
      prev.addEventListener("click", function (e) {
        if(!_this.watchCheck()) {
          return false
        }
        book.package.metadata.direction === "rtl" ? rendition.next() : rendition.prev();
        e.preventDefault();
      }, false);

      var keyListener = function (e) {
        // Left Key
        if ((e.keyCode || e.which) == 37) {
          if(!_this.watchCheck()) {
            return false
          }
          book.package.metadata.direction === "rtl" ? rendition.next() : rendition.prev();
        }

        // Right Key
        if ((e.keyCode || e.which) == 39) {
          if(!_this.watchCheck()) {
            return false
          }
          book.package.metadata.direction === "rtl" ? rendition.prev() : rendition.next();
        }

      };
      rendition.on("keyup", keyListener);
      document.addEventListener("keyup", keyListener, false);
      return book.locations.generate(1600)
    }).then((locations) => {
      displayed.then(() => {
        var currentLocation = rendition.currentLocation();
        this.percentage = book.locations.percentageFromCfi(currentLocation.start.cfi);
      });
    })

    var title = document.getElementById("title");

    rendition.on("rendered", (section) => {
      var re = /.+\//g;
      var menus = section.href.match(re);
      if (menus) {
        _this.menus = menus.join()
      }
      this.catalogues.forEach((item,index)=>{
        if(section.href.indexOf(item.href)!=-1 || item.href.indexOf(section.href)!=-1) {
          this.catalogueName = item.label
        }
      })
    });
    rendition.on("relocated", (location) => {
      this.view++;
      if(this.view == 5) {
        //todo 本书增加一次阅读次数
        var data = {
          ebookId: _this.id,
          libCode: _this.libCode,
          peruser: _this.user?_this.user.idCard : ''
        }
        ajaxUtil.ajaxJson(api.ebook.addEbookReadRecord,data,"POST",(data)=>{
        },null,_this)
      }
      if(!_this.watchCheck()) {
        return false
      }
      this.watchLimit(location.start.cfi);
      this.isSave = false;
      this.bookmark.forEach((item)=>{
        if(location.start.cfi == item.url) {
          this.isSave = true
        }
      })
      this.nowPageUrl = location.start.href;
      this.nowPageCfi = location.start.cfi;
      var percentage = book.locations.percentageFromCfi(location.start.cfi);
      this.percentage = percentage ? percentage : 0
      var next = book.package.metadata.direction === "rtl" ? document.getElementById("prev") : document.getElementById("next");
      var prev = book.package.metadata.direction === "rtl" ? document.getElementById("next") : document.getElementById("prev");

      if (location.atEnd) {
        next.style.visibility = "hidden";
      } else {
        next.style.visibility = "visible";
      }

      if (location.atStart) {
        prev.style.visibility = "hidden";
      } else {
        prev.style.visibility = "visible";
      }

    });
    rendition.on("layout", function (layout) {
      let viewer = document.getElementById("viewer");
      if (layout.spread) {
        viewer.classList.remove('single');
      } else {
        viewer.classList.add('single');
      }
    });

    // 获取目录
    book.loaded.navigation.then(function (toc) {
      _this.catalogues = toc.toc;
    });

  },
  beforeRouteLeave(to,from,next) {
    LocalStorageUtil.removeObject('nowPageCfi');
    if(this.book) {
      this.book.destroy();
    }
    next()
  },
  methods: {
    hidden(){
      //点击取消，则返回开始阅读页面
      this.isReader = false;
      this.goback();

    },
    loginSuccess(data){
       this.loginUser = data;
       this.$refs.loginMask.hideLogin();
      //检查是否是本馆读者
      let url = api.reader.checkReaderEbook.replace('{hallCode}',this.libCode).replace('{readerId}',this.loginUser.readerId);
      ajaxUtil.ajaxJson(url,null,'GET',(data)=>{
       if(data.result){//是本馆读者，直接阅读
         this.isReader = false;
       }else{//不是本馆读者，弹出提示框
         this.isReader = true;
       }
      },null,this);
    },
    inLinbraryReader(){//成为该图书馆读者
      ajaxUtil.ajaxJson(api.reader.addReaderAuthority,{'hallCode':this.libCode,'readerId':this.loginUser.readerId},'POST',(data)=>{
        //添加成功，直接去读电子书
        this.isReader = false;
      },(error)=>{
        this.isReader = false;
        this.goback();
      },this)
    },
    stopWatch() {
      this.loginTip = true;
    },
    watchCheck() {
      if(this.viewTimes > 10 && !store.func.getUserObj() && !StorageUtil.getString("authorizedLogin")) {
        LocalStorageUtil.storeObject('nowPageCfi',this.nowPageCfi);
        this.stopWatch();
        return false
      }
      return true
    },
    watchLimit(cfi) {  /*已登录不计算阅读次数，公共阅读器不计算次数，跳转到同一页面不计算次数*/
      if(this.platform == 1 || store.func.getUserObj() || StorageUtil.getString("authorizedLogin") || this.nowPageCfi == cfi) { /*注：这里的nowPageCfi为上一次的cfi，更新nowPageCfi在这个方法之后*/
        return false
      }

      var viewTimeList = LocalStorageUtil.getObject('viewTimes') || [];
      this.viewTimes++;
      if(this.viewTimes > 10) {
        LocalStorageUtil.storeObject('nowPageCfi',cfi)
        this.stopWatch();
        return false
      }
      var obj = {
        file: this.file,
        times: this.viewTimes
      }
      for(var i = 0; i < viewTimeList.length; i++) {
        if(viewTimeList[i].file == this.file) {
          viewTimeList[i].times = this.viewTimes;
          LocalStorageUtil.storeObject('viewTimes', viewTimeList);
          return false
        }
      }
      viewTimeList.push(obj);
      LocalStorageUtil.storeObject('viewTimes', viewTimeList);
    },
    hide() {
      this.showLabel = false;
      this.showCatalogue =false;
    },
    goback() {
        this.$router.push({name: 'ebookinfo',query: {id:this.id}})
      },
    tologin() {
      //store.index.$refs.login.showLogin();
      this.$refs.loginMask.showLogin();
      this.loginTip = false;
    },
    getChapter(url) { //获取当前章节
      var obj = {
        isChapter: false,
        num:0
      }
      var re = /\d+/g;
      if(url.indexOf('chapter')!=-1) {
        obj.isChapter = true
      }
      obj.num = url.match(re)?parseInt(url.match(re)[0]): 0
      return obj
    },
    makeDelete() {
      var cfi = this.deleteNewsUrl;
      if(cfi == this.nowPageCfi) {
        this.isSave = false
      }
      this.cancleMsg();
      for(var i = 0; i < this.bookmark.length; i++) {
        if(cfi == this.bookmark[i].url) {
          this.bookmark.splice(i,1)
          LocalStorageUtil.storeObject('bookmark',this.bookmark)
          return false;
        }
      }
    },
    deleteBookMark(cfi) {
      this.deleteNews = true;
      this.deleteNewsUrl = cfi;
    },
    cancleMsg() {
      this.deleteNews = false;
      this.deleteNewsUrl = '';
    },
    saveLabel() {
      this.isSave = !this.isSave
      for(var i = 0; i < this.bookmark.length; i++) {
        if(this.nowPageCfi == this.bookmark[i].url) {
          this.bookmark.splice(i,1)
          LocalStorageUtil.storeObject(this.file,this.bookmark)
          return false;
        }
      }
      var label = {
        file: this.file,
        url: this.nowPageCfi,
        name: this.catalogueName,
        percentage: parseInt(Number(this.percentage).toFixed(2) * 100),
        date: new Date().pattern('yyyyMMdd HH:mm')
      }
      this.catalogues.forEach((item, index)=>{
        if(item.href == this.nowPageUrl) {
          label.name = item.label
        }
      })
      this.bookmark.push(label)
      LocalStorageUtil.storeObject(this.file,this.bookmark)
    },
    toLabel(cfi) {
      if(!this.watchCheck()) {
        return false
      }
      this.showLabel = false;
      this.rendition.display(cfi);
    },
    tochapter(index) {
      if(!this.watchCheck()) {
        return false
      }
      var url = this.catalogues[index].href
      this.showCatalogue = false;
      if(url.indexOf(this.menus)==0) {
        this.rendition.display(url, 5);
      } else {
        this.rendition.display(this.menus + url, 5);
      }
    },
    changeCatalogueStatus() {
      setTimeout(()=>{
        this.showLabel = false;
        this.showCatalogue = !this.showCatalogue;
        if(this.showCatalogue) {
          this.$nextTick(()=>{
            var labelItemHeight = this.catalogues.length * 49;
            var wrapper = document.getElementsByClassName('catalogueWrapper')[0];
            var wrapperHeight = wrapper.getBoundingClientRect().height;
            if(wrapperHeight/labelItemHeight > 1) {
              this.scrollBarHeight_catalogue = 0;
              return  false;
            }
            this.scrollBarHeight_catalogue = wrapperHeight / labelItemHeight * wrapperHeight + 'px';
            var drag = this.$refs.scrollBar_catalogue;
            var box = this.$refs.scroll_catalogue;
            var con = this.$refs.catalogues;
            var out = this.$refs.catalogueWrapper;
            this.addScroll(drag,box,con,out)
          })
        }
      })
    },
    changeLabelStatus() {
      setTimeout(()=>{
        this.showCatalogue = false;
        this.showLabel = !this.showLabel
        if(this.showLabel) {
          this.$nextTick(()=>{
            var labelItemHeight = this.bookmark.length * 100+66;
            var wrapper = document.getElementsByClassName('labelWrapper')[0];
            var wrapperHeight = wrapper.getBoundingClientRect().height;
            if(wrapperHeight/labelItemHeight > 1) {
              this.scrollBarHeight = 0;
              return  false;
            }
            this.scrollBarHeight = wrapperHeight / labelItemHeight * wrapperHeight + 'px';
            var drag = this.$refs.scrollBar;
            var box = this.$refs.scroll;
            var con = this.$refs.labels;
            var out = this.$refs.labelWrapper;
            this.addScroll(drag,box,con,out)
          })
        }
      })
    },
    addScroll(drag,box,con,out) {
      drag.onmousedown = function (ev) {
        var e = ev || window.event;
        if (e.preventDefault) {
          e.preventDefault();
        } else {
          e.returnValue = false;
        };
        var d_bkt = e.clientY - drag.offsetTop;
        document.onmousemove = function (ev) {
          var e = ev || window.event;
          var top = e.clientY - d_bkt;
          if (top <= 0) {
            top = 0;
          };
          if (top >= box.clientHeight - drag.clientHeight) {
            top = box.clientHeight - drag.clientHeight;
          };
          var scale = top / (box.clientHeight - drag.clientHeight);
          var cony = scale * (con.clientHeight - out.clientHeight);
          drag.style.top = top + 'px';
          con.style.top = -cony + 'px';
        }
        document.onmouseup = function () {
          document.onmousemove = null;
        }
      }
      var str = window.navigator.userAgent.toLowerCase();
      if (str.indexOf('firefox') != -1) {//火狐浏览器
        out.addEventListener('DOMMouseScroll', function (e) {
          e.preventDefault();//阻止窗口默认的滚动事件
          if (e.detail < 0) {
            var t = con.offsetTop + 20;
            if (t >= 0) {
              t = 0;
            };
            if (t <= -(con.clientHeight - out.clientHeight)) {
              t = -(con.clientHeight - out.clientHeight);
            };
            var scale = t / (con.clientHeight - out.clientHeight);
            var top = scale * (box.clientHeight - drag.clientHeight);
            con.style.top = t + 'px';
            drag.style.top = -top + 'px';
          };
          if (e.detail > 0) {
            var t = con.offsetTop - 20;
            if (t >= 0) {
              t = 0;
            };
            if (t <= -(con.clientHeight - out.clientHeight)) {
              t = -(con.clientHeight - out.clientHeight);
            };
            var scale = t / (con.clientHeight - out.clientHeight);
            var top = scale * (box.clientHeight - drag.clientHeight);
            con.style.top = t + 'px';
            drag.style.top = -top + 'px';
          };
        }, false);
      } else {//非火狐浏览器
        out.onmousewheel = function (ev) {
          var e = ev || window.event;
          if (e.preventDefault) {
            e.preventDefault();
          } else {
            e.returnValue = false;
          };
          if (e.wheelDelta > 0) {
            var t = con.offsetTop + 20;
            if (t >= 0) {
              t = 0;
            };
            if (t <= -(con.clientHeight - out.clientHeight)) {
              t = -(con.clientHeight - out.clientHeight);
            };
            var scale = t / (con.clientHeight - out.clientHeight);
            var top = scale * (box.clientHeight - drag.clientHeight);
            con.style.top = t + 'px';
            drag.style.top = -top + 'px';
          };
          if (e.wheelDelta < 0) {
            var t = con.offsetTop - 20;
            if (t >= 0) {
              t = 0;
            };
            if (t <= -(con.clientHeight - out.clientHeight)) {
              t = -(con.clientHeight - out.clientHeight);
            };
            var scale = t / (con.clientHeight - out.clientHeight);
            var top = scale * (box.clientHeight - drag.clientHeight);
            con.style.top = t + 'px';
            drag.style.top = -top + 'px';
          };
        }
      }
    }
  }
}
